import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-mcommerce-audit-config-card',
  templateUrl: './mcommerce-audit-config-card.component.html',
  styleUrls: ['./mcommerce-audit-config-card.component.scss']
})
export class McommerceAuditConfigCardComponent implements OnInit {

  @Input() data;

  constructor() { }

  ngOnInit() {
  }

}
